import { Cytomine } from '@/api';
import { getTemporaryAccessToken } from '@/bootstrap/auth.js';
import { updateToken } from '@/utils/token-utils';

export function createAuthorizationHeaderInterceptor({ store, keycloak }) {
  return async config => {
    if (keycloak.hasTemporaryToken) {
      const accessToken = getTemporaryAccessToken();

      if (accessToken) {
        config.params = config.params || {};
        config.params.access_token = accessToken;
        store.commit('currentUser/setShortTermToken', accessToken);
      }

      return config;
    }

    const token = await updateToken();
    config.headers = config.headers || {};

    if (token !== null) {
      store.commit('currentUser/setShortTermToken', token);
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  };
}

export function initializeApiClient({
  store,
  keycloak,
  host = window.location.origin,
  basePath = '/api/',
} = {}) {
  const authorizationHeaderInterceptor = createAuthorizationHeaderInterceptor({ store, keycloak });

  return new Cytomine(
    host,
    basePath,
    `/iam/realms/${keycloak.realm}`,
    authorizationHeaderInterceptor
  );
}
